import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faSearch, faArrowLeft, faArrowRight, faAdd, faSave } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './TruckForm.css'
import { Tooltip } from 'react-tooltip';
import { useNavigate } from 'react-router-dom';
import GoCast from '../../Images/GoCast.png'
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
const ApproveGride = () => {


    const [isLoading, setIsLoading] = useState(false); // Loading GIF

    // Navigation To Another Page
    const navigate = useNavigate();

    // Table visibility
    const [tableVisible, setTableVisible] = useState(true);

    // Toggle table visibility
    const toggleTableVisibility = () => {
        setTableVisible(!tableVisible);
    }
    //        API CODE
    const [apiData, setApiData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Adjust this number as needed
    const [originalApiData, setOriginalApiData] = useState([]);

    //ADD 
    const [showEmptyRow, setShowEmptyRow] = useState(false);
    const [modifiedData, setModifiedData] = useState([]); // New state for modified data
    const [modifiedRows, setModifiedRows] = useState(new Set()); // New state to track modified rows
    const [Key1, setKey1] = useState('');
    const [Character01, setCharacter01] = useState('');
    const [Character02, setCharacter02] = useState('');
    const [Character03, setCharacter03] = useState('');
    const [CheckBox01, setCheckBox01] = useState(false);

    const fetchData = async () => {
        setIsLoading(true); // Load GIF
        const username = 'manager'; // Replace with your username
        const password = 'manager'; // Replace with your password
        const apiUrl = 'https://77.92.189.102/IITPrecastVertical/api/v1/BaqSvc/IIT_ProductionPlanner_v2(PRECAST)'; // Adjust the URL as needed

        try {
            const response = await fetch(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            // Check if data is an object and contains the 'value' property which is an array
            if (typeof data === 'object' && data !== null && Array.isArray(data.value)) {
                setApiData(data.value);
                setModifiedData(data.value);
                setOriginalApiData(data.value);
                setIsLoading(false); // Loading GIF
            } else {
                console.error('API response does not contain the expected array in the "value" property:', data);
            }
        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
        }
    };
    useEffect(() => {
        fetchData();
    }, []); // Fetch data on component mount

    const handleInputChange = (e, index, field) => {
        const newValue = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        const newData = [...modifiedData];
        newData[index][field] = newValue;
        setModifiedData(newData);
        setModifiedRows(new Set(modifiedRows.add(index))); // Add the index to modifiedRows set
        console.log(modifiedRows);
    };

    // const handleFilterChange = (e) => {
    //     const inputValue = e.target.value;
    //     setFilter(inputValue);

    //     // If the input value is cleared, reset apiData to the original data
    //     if (inputValue === '') {
    //         setApiData(originalApiData);
    //     } else {
    //         // Filter apiData based on the input value, ensuring Key1 is defined
    //         const filteredData = apiData.filter(item => item.Key1 && item.Key1.includes(inputValue));
    //         setApiData(filteredData); // Update apiData with filtered data
    //     }
    // };
    const saveData = async () => {
        const username = 'manager';
        const password = 'manager';
        const apiUrl = 'https://77.92.189.102/IITPrecastVertical/api/v1/BaqSvc/IIT_ProductionPlanner_v2(PRECAST)/'; // Adjust the URL as needed

        try {
            for (const rowIndex of modifiedRows) {
                const response = await axios.patch(apiUrl, modifiedData[rowIndex], {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + btoa(username + ":" + password)
                    }
                });
                console.log('Data saved successfully:', response.data);
            }
            setIsLoading(false); // Load GIF
                setTimeout(() => {
                    toast.success("Data Saved Successfully");
                }, 10);
        } catch (error) {
            console.error('Error:', error.message);
            setIsLoading(false); // Loading GIF
            // Toast Notifcation
            setTimeout(() => {
                toast.error("Failed To Save");
            }, 10);
        }
    };
    

    const renderTableRows = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentItems = apiData.slice(startIndex, endIndex);

        return (
            <>
                {currentItems.map((item, index) => (
                    <tr key={index} >
                        {/* <td>
                            <input
                                type="checkbox"
                                checked={item.JobHead_JobReleased}
                            />
                        </td> */}
                        <td><input className='UpdateInput' type="checkbox" checked={modifiedData[startIndex + index].PartLot_ClientApproved_c} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_ClientApproved_c')} /></td>

                        <td>{item.PartLot_LotNum}</td>
                        <td>{item.JobHead_ProdQty}</td>
                        <td>{item.JobHead_IUM}</td>
                        <td>{new Date(item.PartLot_EstimatedCastingDate_c).toLocaleDateString('en-US')}</td>
                        <td>{new Date(item.Calculated_ErectReqDate).toLocaleDateString('en-US')}</td>
                        <td>{item.PartLot_M3_c}</td>
                        <td>{item.PartLot_M2_c}</td>
                        <td>{item.PartLot_Ton_c}</td>
                        <td>{item.PartLot_Width_c}</td>
                        <td>{item.PartLot_Height_c}</td>
                        <td>{item.Calculated_ConcereteMix}</td>
                        <td>
                            <input
                            type="checkbox"
                            checked={item.Calculated_Rebar? 'true' : ''}
                            /> 
                        </td>
                        <td>{item.JobHead_JobNum}</td>
                        <td>{item.PartLot_TypicalID_c}</td>
                        <td>{item.PartLot_BuildingType_c}</td>
                        <td>{item.PartLot_BuildingNumber_c}</td>
                        <td>{item.PartLot_Floor_c}</td>
                        <td>{item.PartLot_PartNum}</td>
                        <td>{item.JobOper_OprSeq}</td>
                        <td>{item.JobOpDtl_OpDtlSeq}</td>    
                    </tr>

                ))}
            </>
        );
    };
    const goToNextPage = () => {
        const totalPages = Math.ceil(apiData.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    return (
        <div className='card rebartable'>
            <ToastContainer />
            {isLoading && (
                <div className="loading-overlay">
                    <img src={GoCast} alt="Loading..." />
                </div>
            )}
            <div className="card-header">
                {/* <button type="button" className="toggle-table-icon" onClick={toggleTableVisibility}>
                    <FontAwesomeIcon icon={tableVisible ? faArrowDown : faArrowUp} />
                </button> */}
                <h2 className='panel-title-truckform'>Elements Approval</h2>
                {/* <div className='Truck-id-container'>
                    <input type='text' placeholder=' Truck ID' className='Containeridinput-Truck' onChange={handleFilterChange} />
                   
                </div> */}
                <div className='ctrl-btns-rebar'>
                    {/* <button className="btn" id='add' onClick={addNewRow}>
                        <FontAwesomeIcon icon={faAdd} />
                    </button>
                    <Tooltip
                        anchorSelect="#add"
                        content="Add"
                        place='bottom'
                    /> */}
                    <button className="btn" id='save' onClick={saveData}>
                        <FontAwesomeIcon icon={faSave} />
                    </button>
                    <Tooltip
                        anchorSelect="#save"
                        content="Save"
                        place='bottom'
                    />
                </div>

            </div>
            {/* Conditionally render the table */}
            {tableVisible && (
                <div className="card-body">
                    <div class="table-responsive">
                        <div className="scrollable-table-body">
                            <table className="table table-bordered">
                                {/* Table content */}
                                <thead className='table-primary'>
                                    <tr className='bg-primary text-white'>
                                        <th>Released</th>
                                        <th>Element ID</th>
                                        <th>Unit/Each</th>
                                        <th>UOM</th>
                                        <th>Required By Casting Date</th>
                                        <th>Required By Erection Date</th>
                                        <th>Volume</th>
                                        <th>Area</th>
                                        <th>Weight</th>
                                        <th>Width</th>
                                        <th>Height</th>
                                        <th>Concrete Mix</th>
                                        <th>Rebar</th>
                                        <th>Job Number</th>
                                        <th>Typical ID</th>
                                        <th>ID1</th>
                                        <th>ID2</th>
                                        <th>ID3</th>
                                        <th>Part</th>
                                        <th>Opr</th>
                                        <th>OpDtlSeq</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {renderTableRows()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="pagination">
                        <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </button>
                        <button onClick={goToNextPage} disabled={currentPage === Math.ceil(apiData.length / itemsPerPage)}>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ApproveGride;

